import React, { ForwardRefRenderFunction, useEffect, useImperativeHandle, useRef, useState } from 'react'

import { MapTypeId, setMarker, createGoogleMaps, createGoogleInput } from './googleMaps'

type MapProps = {
  mapTypeId: MapTypeId,
  onMarker?: (lat: number, lng: number) => void
}

type InputProps = {
  onChange?: (lat: number, lng: number, address?: string) => void
}

export interface MapRef {
  init: () => void,
  setMarker: (lat: number, lng: number, center?: boolean) => void,
}

export interface InputRef {
  init: () => void
}

type MapOpts = ForwardRefRenderFunction<MapRef, MapProps>
type InputOpts = ForwardRefRenderFunction<InputRef, InputProps>

const MapComponent: MapOpts = ({ mapTypeId, onMarker }, ref) => {
  const googleMapsRef = useRef<HTMLDivElement>(null)

  // Initiate Google Maps
  useEffect(() => {
    if (googleMapsRef.current) {

    }
    // eslint-disable-next-line
  }, [googleMapsRef.current])

  useImperativeHandle(ref, () => ({
    init: (): void => {
      if (googleMapsRef.current) {
        createGoogleMaps(googleMapsRef.current, mapTypeId).then(googleMaps => {
          if (googleMaps) {
            googleMaps.addListener('click', (e) => {
              const [lat, lng] = [e.latLng.lat(), e.latLng.lng()]
              setMarker(lat, lng)
              if (onMarker) {
                onMarker(lat, lng)
              }
            })
          }
        })
      }
    },
    setMarker: (lat: number, lng: number, center = true): void => {
      setMarker(lat, lng, center)
    }
  }))

  return (
    <div className='row' style={{ height: '100%' }} ref={googleMapsRef}></div>
  )
}

export const InputComponent: InputOpts = ({ onChange }, ref) => {
  const [place, setPlace] = useState('')
  const googleInputRef = useRef<HTMLInputElement|null>(null)

  // Initiate Google Maps Autocomplete Input
  useImperativeHandle(ref, () => ({
    init: (): void => {
      if (googleInputRef.current) {
        createGoogleInput(googleInputRef.current).then(googleInput => {
          if (googleInput) {
            googleInput.addListener('place_changed', () => {
              const nearPlace = googleInput.getPlace()
              if (nearPlace.geometry) {
                const { geometry: { location } } = nearPlace
                const [lat, lng] = [location.lat(), location.lng()]

                if (onChange) {
                  onChange(lat, lng, nearPlace.formatted_address)
                }
              } else {
                console.log('Geometry doesn\'t found')
              }
            })
          }
        })
      }
    }
  }))

  return (
    <input
      type="text"
      value={place}
      onChange={(e): void => setPlace(e.target.value)}
      ref={googleInputRef}
    />
  )
}

export const Map = React.forwardRef(MapComponent)
export const Input = React.forwardRef(InputComponent)
